// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/certificates1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Certificates_certificatesHeader__\\+BaF5 {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.Certificates_certificatesHeader__\\+BaF5 .Certificates_videoTag__zpQs6 {
  width: 100%;
}
.Certificates_certificatesHeader__\\+BaF5 .Certificates_layer__Q3pWp {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.Certificates_certificatesHeader__\\+BaF5 p {
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  max-width: 700px;
  z-index: 1;
  padding-top: 30px;
}
@media (max-width: 780px) {
  .Certificates_certificatesHeader__\\+BaF5 p {
    width: 95%;
  }
}

.Certificates_headingCertificate__25AF0 {
  text-align: center;
  font-family: "hemi_head";
  font-style: italic;
  font-weight: 400;
  font-size: 40px;
  color: #FFFFFF;
  margin: 0;
  z-index: 1;
}
@media (max-width: 780px) {
  .Certificates_headingCertificate__25AF0 {
    font-size: 30px;
  }
}
@media (max-width: 400px) {
  .Certificates_headingCertificate__25AF0 {
    font-size: 25px;
  }
}

.Certificates_certificatesBox__WRvyK {
  width: 80%;
  margin: auto;
  padding: 50px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
@media (max-width: 670px) {
  .Certificates_certificatesBox__WRvyK {
    justify-content: center;
    align-items: center;
  }
}
.Certificates_certificatesBox__WRvyK .Certificates_certificatesBackground__c-cKA {
  background-size: 100% 100%;
  filter: blur(5px);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
}
.Certificates_certificatesBox__WRvyK .Certificates_certificatesItem__sspWR {
  position: relative;
  z-index: 1;
  width: 258px;
  height: 160px;
  background: #EDEDED;
  border: 1px solid #FFFFFF;
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 50px;
}
.Certificates_certificatesBox__WRvyK .Certificates_certificatesItem__sspWR img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.Certificates_certificatesBox__WRvyK .Certificates_certificatesItem__sspWR h4 {
  font-size: 20px;
  font-family: "hemi_head";
  color: #FFFFFF;
  text-shadow: 3px 3px 4px rgba(0, 0, 0, 0.25), 3px 3px 4px rgba(11, 2, 2, 0.25);
}
.Certificates_certificatesBox__WRvyK .Certificates_certificatesItem__sspWR p {
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  text-align: center;
  color: #FFFFFF;
  text-shadow: 4px 1px 4px #020202;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Certificates/Certificates.module.scss"],"names":[],"mappings":"AAAA;EAEE,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AAEE;EACE,WAAA;AAAJ;AAGE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,mDAAA;AADJ;AAIE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,+BAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;AAFJ;AAGI;EARF;IASI,UAAA;EAAJ;AACF;;AAGA;EACI,kBAAA;EACA,wBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;AAAJ;AACI;EATJ;IAUM,eAAA;EAEJ;AACF;AADI;EAZJ;IAaM,eAAA;EAIJ;AACF;;AAFA;EACE,UAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;AAKF;AAJE;EAPF;IAQI,uBAAA;IACA,mBAAA;EAOF;AACF;AALE;EACE,0BAAA;EACA,iBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AAOJ;AAJE;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;AAMJ;AAHI;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAKN;AAFI;EACE,eAAA;EACA,wBAAA;EACA,cAAA;EACA,8EAAA;AAIN;AADI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gCAAA;AAGN","sourcesContent":[".certificatesHeader {\n  //min-height: calc(100vh - 100px);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n\n  .videoTag {\n    width: 100%;\n  }\n\n  .layer {\n    position: absolute;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    background: url(\"../../Assets/Images/certificates1.png\");\n  }\n\n  p {\n    font-size: 20px;\n    line-height: 23px;\n    text-align: center;\n    color: rgba(255, 255, 255, 0.7);\n    max-width: 700px;\n    z-index: 1;\n    padding-top: 30px;\n    @media (max-width: 780px) {\n      width: 95%;\n    }\n  }\n}\n.headingCertificate{\n    text-align: center;\n    font-family: 'hemi_head';\n    font-style: italic;\n    font-weight: 400;\n    font-size: 40px;\n    color: #FFFFFF;\n    margin: 0;\n    z-index: 1;\n    @media (max-width: 780px) {\n      font-size: 30px;\n    }\n    @media (max-width: 400px) {\n      font-size: 25px;\n    }\n}\n.certificatesBox {\n  width: 80%;\n  margin: auto;\n  padding: 50px 0;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  @media (max-width: 670px) {\n    justify-content: center;\n    align-items: center;\n  }\n\n  .certificatesBackground {\n    background-size: 100% 100%;\n    filter: blur(5px);\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: -1;\n  }\n\n  .certificatesItem {\n    position: relative;\n    z-index: 1;\n    width: 258px;\n    height: 160px;\n    background: #EDEDED;\n    border: 1px solid #FFFFFF;\n    border-radius: 7px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: center;\n    margin-bottom: 50px;\n\n\n    img {\n      width: 100%;\n      height: 100%;\n      object-fit: contain;\n    }\n\n    h4 {\n      font-size: 20px;\n      font-family: \"hemi_head\";\n      color: #FFFFFF;\n      text-shadow: 3px 3px 4px rgba(0, 0, 0, 0.25), 3px 3px 4px rgba(11, 2, 2, 0.25);\n    }\n\n    p {\n      font-weight: 400;\n      font-size: 13px;\n      line-height: 16px;\n      text-align: center;\n      color: #FFFFFF;\n      text-shadow: 4px 1px 4px #020202;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"certificatesHeader": `Certificates_certificatesHeader__+BaF5`,
	"videoTag": `Certificates_videoTag__zpQs6`,
	"layer": `Certificates_layer__Q3pWp`,
	"headingCertificate": `Certificates_headingCertificate__25AF0`,
	"certificatesBox": `Certificates_certificatesBox__WRvyK`,
	"certificatesBackground": `Certificates_certificatesBackground__c-cKA`,
	"certificatesItem": `Certificates_certificatesItem__sspWR`
};
export default ___CSS_LOADER_EXPORT___;
